import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'

/**
 * @param {{ title: string, description?: string, actions?: React.ReactNode }} props
 */
export default function PageHeader({ title, description, actions }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 2,
        mb: 2,
        flexWrap: 'wrap',
      }}
    >
      <Box>
        <Typography
          variant="h5"
          component="h1"
          sx={(theme) => ({
            fontWeight: 900,
            color: 'text.primary',
            textShadow: theme.palette.mode === 'dark' ? '0 6px 28px rgba(91,63,214,0.22)' : 'none',
            '&::before': {
              content: '"♦"',
              mr: 1,
              color: 'secondary.main',
              fontSize: '0.72em',
              verticalAlign: 'middle',
            },
          })}
        >
          {title}
        </Typography>
        {description ? (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, maxWidth: 720 }}>
            {description}
          </Typography>
        ) : null}
      </Box>
      {actions ? <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>{actions}</Stack> : null}
    </Box>
  )
}
